import { render, staticRenderFns } from "./SimpleItem.vue?vue&type=template&id=50739020&scoped=true&lang=pug&"
import script from "./SimpleItem.vue?vue&type=script&lang=js&"
export * from "./SimpleItem.vue?vue&type=script&lang=js&"
import style0 from "./SimpleItem.vue?vue&type=style&index=0&id=50739020&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50739020",
  null
  
)

export default component.exports